import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header-payment',
  templateUrl: './header-payment.component.html',
  styleUrls: ['./header-payment.component.scss']
})
export class HeaderPaymentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
